module.exports = __webpack_public_path__ + "annualreview2017/static/img/black-asian-ethnic@0,5x.2331fa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/people/black-asian-ethnic@0,5x.jpg
// module id = 765
// module chunks = 0